export const MIN_SCALE = 0.25;
export const MAX_SCALE = 2.5;
export const PALETTE = ["#082D4A", "#D4A017", "#3B82F6", "#8B5CF6", "#0EA5E9", "#D97706", "#DB2777", "#059669", "#7C3AED", "#DC2626"];
export const THEME_LABELS = { classic: "Classic", compact: "Compact", photo: "Photo-first" };
export const ORIENTATIONS = { down: "Top-down (classic)", up: "Bottom-up (roots below)", right: "Left → Right", left: "Right → Left", radial: "Radial (fan chart)" };
export const CTRL_BTN = "bg-white shadow-sm";
export const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
export const hexA = (hex, a) => {
  const h = hex.replace("#", "");
  return `rgba(${parseInt(h.slice(0, 2), 16)},${parseInt(h.slice(2, 4), 16)},${parseInt(h.slice(4, 6), 16)},${a})`;
};
// Overlays sit on top of the pan surface: swallow pointerdown so clicks never start a canvas pan.
export const stopPointer = (e) => e.stopPropagation();
